
const winningCombinations = [
  [[0,0], [1,0], [2,0]],
  [[0,1], [1,1], [2,1]],
  [[0,2], [1,2], [2,2]],
  [[0,0], [0,1], [0,2]],
  [[1,0], [1,1], [1,2]],
  [[2,0], [2,1], [2,2]],
  [[0,0], [1,1], [2,2]],
  [[2,0], [1,1], [0,2]]
];

const signs = ['X', 'O'];

export const winner = (tilesArray) => {
  let winningPerson = 0;
  
  // Check all winning combinations for both signs
  signs.map((sign) => {
  winningCombinations.map((line) => {
    if (sign === tilesArray[line[0][0]][line[0][1]] &&
        sign === tilesArray[line[1][0]][line[1][1]] &&
        sign === tilesArray[line[2][0]][line[2][1]]) {
          switch (sign) {
            case 'X': 
              winningPerson = 1;
              break;
            case 'O': 
              winningPerson = 2;
              break;
            default:
              break;
          }
        }
    })
  });

  // Check, if all fields are full, but nobody won -> draw
  if (tilesArray.flat(Infinity).indexOf('E') === -1 && winningPerson === 0) {
    winningPerson = 3;
  }
  return winningPerson;
}